import { Config } from '@/config'
import { appSelectors, useAppStore } from '@/store'
import { useCallback } from 'react'

export const useLocalizedRoutes = () => {
  const locale = useAppStore(appSelectors.locale)

  const get = useCallback(
    (route: string) => {
      const routeWoSlashes = route.replace(/^\//, '')
      return `/${locale ?? Config.FALLBACK_LANG}/${routeWoSlashes}`
    },
    [locale],
  )

  return {
    get,
  }
}
